// extracted by mini-css-extract-plugin
export default {"main":"TriggerEmergency_main__ZZ4KZ","container":"TriggerEmergency_container__Reulb"};